<div class="flex flex-col justify-center items-center w-full bg-gray-100 p-6">
    <div class="bg-white shadow-lg rounded-lg p-6 w-full md:w-1/2">
        <!-- Success Header -->
        <h2 class="text-2xl font-semibold text-gray-900 text-center mb-4">Booking Successful</h2>

        <div class="bg-green-100 rounded p-3">
            <!-- Confirmation Message -->
            <div class="text-center space-y-2">
                <p class="text-lg text-gray-700">
                    Your booking request has been <u>submitted</u>.
                </p>
                <p class="text-lg text-gray-700">
                    You will be notified via email once your booking time is confirmed.
                </p>
            </div>
        </div>
        <!-- Lottie Animation -->
        <div class="flex w-full justify-center">
            <ng-lottie #lotani [options]="lottieConfig" width="150px" height="150px"
                (animCreated)="handleAnimation($event)">
            </ng-lottie>
        </div>

        <!-- Booking Details -->

        <div class=" flex w-full justify-between items-center border-b pb-4 mt-4">
            <div class="flex items-center space-x-3 basis-0 " style="flex-grow: 2;">
                <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:user"
                    matTooltip="Client Name"></mat-icon>
                <div>
                    <div class="text-gray-700 font-medium text-sm">Client Name</div>
                    <div class="text-gray-500">{{data.bookingdata.client_first_name}}&nbsp;{{data.bookingdata.client_last_name}}
                    </div>
                </div>
            </div>

            <div class="flex items-center space-x-3 basis-0" style="flex-grow: 1;">
                <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:envelope"
                    matTooltip="Email Address"></mat-icon>
                <div>
                    <div class="text-gray-700 font-medium text-sm">Client Email</div>
                    <div class="text-gray-500">{{data.bookingdata.client_email}}</div>
                </div>
            </div>
        </div>

        <!-- Booking Time & Date -->
        <div class=" flex w-full justify-between items-center border-b pb-4 mt-4">
            <div class="flex items-center space-x-3 basis-0" style="flex-grow: 2;">
                <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:clock"
                    matTooltip="Booking Duration"></mat-icon>
                <div>
                    <div class="text-gray-700 font-medium text-sm">Booking Duration</div>
                    <div class="text-gray-500">{{data.bookingduration}}&nbsp;minutes</div>
                </div>
            </div>

            <div class="flex items-center space-x-3 basis-0" style="flex-grow: 1;">
                <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:calendar"
                    matTooltip="Booking Date"></mat-icon>
                <div>
                    <div class="text-gray-700 font-medium text-sm">Booking Date</div>
                    <div class="text-gray-500 text-sm">{{data.bookingdata.appointment_start_time | date: 'MM-dd-yyyy hh:mm aa' : 'UTC'}}&nbsp;{{data.bookingdata.timezone}}</div>
                </div>
            </div>
        </div>


        <div class="w-full flex justify-center py-3">
            <button (click)="loadBookingPage()" mat-raised-button color="primary" class="w-1/2" type="submit">
                Book Another Appointment
            </button>
        </div>
    </div>
</div>